<template>
  <div id="footer">
    <div class="footerSection">
      <span>
        <a href="https://dharma-treasure.org/" target="_blank">
          {{$t('avatamsaka.footer.webTreasure')}}
        </a>
      </span>
      <span>
        <a href="https://adarsha.dharma-treasure.org/" target="_blank">
          {{$t('avatamsaka.footer.webAdarsha')}}
        </a>
      </span>
      <span>
        <a href="https://digital-toolbox.dharma-treasure.org/" target="_blank">
          {{$t('avatamsaka.footer.webToolBox')}}
        </a>
      </span>
      <span>
        <a href="https://dharmaebooks.org/" target="_blank">
          {{$t('avatamsaka.footer.webEBook')}}
        </a>
      </span>
      <span>
        <a href="https://support.dharma-treasure.org/" target="_blank">
          {{$t('avatamsaka.footer.webSupport')}}
        </a>
      </span>

    </div>

    <div class="footerInfo">
      <div class="logo">
        <img src="@/../static/image/LOGO.png"/>
      </div>
      <div class="contactInfo">
        {{$t('avatamsaka.footer.eMail')}}<br>
        {{$t('avatamsaka.footer.tel')}}<br>
        {{$t('avatamsaka.footer.address')}}
      </div>
      <div class="copyRight">
        {{$t('avatamsaka.footer.copyRight')}}<br>
        <img src="../assets/copyRight.png">
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'siteFooter',
  data: () => ({

  }),
};
</script>

<style lang="scss" scoped>

  #footer {

    background: #31342B;
    color: #ffffff;

    a {
      color: #ffffff;
    }

    .footerSection {
      background: #505444;
      padding: 20px;

      span::after {
        content: '|';
      }
      span:last-child::after {
        content: '';
      }

    }

    .footerInfo {
      padding: 20px;

      .logo {
        width: calc(50% - 130px);
        padding: 20px;
        text-align: right;
        float: left;
        img {
          width: 32%;
          max-width: 220px;
          min-width: 50px;

        }
      }

      .contactInfo {
        width: calc(50% - 40px);
        text-align: left;
        padding: 20px;
        float: left;
      }

      .copyRight {
        clear: both;
        img {
          width: 100px;
          height: 35px;
        }
      }
    }

    @media (max-width: 768px) {
      .footerInfo {

      .logo {
        width: 100%;
        text-align: center;
        float: none;
        img {
          width: 100%;
        }
      }

      .contactInfo {
        width: 100%;
        text-align: center;
        padding: 20px;
        float: none;
      }
        }
    }

  }


</style>



// WEBPACK FOOTER //
// src/components/Footer.vue